import PropTypes from "prop-types";
import React from "react";
import featureIconData from "../../data/feature-icons/feature-icon.json";
import FeatureIconSingle from "../../components/feature-icon/FeatureIconSingle";

const FeatureIcon = ({ block }) => {
  return (
    <div
      className={`support-area ${block.spaceTopClass ? block.spaceTopClass : ""} ${
        block.spaceBottomClass ? block.spaceBottomClass : ""
      }`}
    >
      <div className="container">
        <div className="row">
          {block.componentData.map(singleFeature => {
            return (
              <FeatureIconSingle
                singleFeature={singleFeature}
                key={singleFeature.id}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

FeatureIcon.propTypes = {
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};

export default FeatureIcon;
